import type { IMetricsSlice } from './pd.index'
import type { RootState } from '..'

import { createSelector } from 'reselect'

export const getApp = (state: RootState) => state.metrics

export const selectData = createSelector(getApp, (app: IMetricsSlice) => {
  return app.data
})
export const selectIsLoading = createSelector(getApp, (app: IMetricsSlice) => {
  return app.isLoading
})
export const selectCount = createSelector(getApp, (app: IMetricsSlice) => {
  return app.count
})
export const selectFileType = createSelector(getApp, (app: IMetricsSlice) => {
  return app.fileType
})
export const selectEventType = createSelector(getApp, (app: IMetricsSlice) => {
  return app.eventType
})
export const selectEventMapping = createSelector(getApp, (app: IMetricsSlice) => {
  return app.eventTypeMapping
})
export const selectNotification = createSelector(getApp, (app: IMetricsSlice) => {
  return app.notification
})
